import React from 'react';
import WOIconWithTag from './../assets/images/logoWithTag.png';
const EmailFooter = () => {
  return (
    <div className="flex flex-col items-center ">
      <img src={WOIconWithTag} alt="WOIcon" />
      <span className="font-sans text-[11px] font-normal text-tab-grey">
        Questions? <span className="text-wo-blue">Contact Us</span>. Let your
        WideOrbit administrator know if you do not wish to receive these updates
        in the future.
      </span>
    </div>
  );
};

export default EmailFooter;
